import React from "react";
import { Button, TextField, FormControlLabel, Checkbox } from "@material-ui/core";
import { HeaderBlock } from "../../../components/header-block/HeaderBlock";
import styles from "./CreateObjectivePage.module.scss";
import PageContainer from "../../../components/page-container/PageContainer";
import { withTranslation } from "react-i18next";
import i18n from "../../../i18n";

const form = [
  { type: "text", id: "name", label: i18n.t('form.name') },
  { type: "text", id: "description", label: i18n.t('objective.form-description') },
  { type: "number", id: "versionNumber", label: i18n.t('objective.version-number') },
  {
    type: "boolean",
    id: "allowsPartialCompletion",
    label: i18n.t('objective.allow-partial-completion')
  }
];

class CreateObjectivePage extends React.Component {
  constructor() {
    super();

    this.state = {

    }
  }

  generateFormItem(item) {
    if (item.type === "text") {
      return (
        <TextField
          id="outlined-name"
          label={item.label}
          margin="normal"
          variant="outlined"
          // margin="dense"
        />
      );
    } else if (item.type === "boolean") {
      return (
        <FormControlLabel
          control={
            <Checkbox
              checked={this.state[item.id]}
              onChange={() => this.setState({ [item.id]: !this.state[item.id] })}
              value={item.id}
            />
          }
          label={item.label}
        />
      );
    }
  }

  render() {
    return (
      <div>
        <HeaderBlock
          title={this.props.t('objective.create-form')}
          right={
            <Button variant="outlined" color="secondary">
              {this.props.t('common.save')}
            </Button>
          }
        />
        <PageContainer>
          <form className={styles.form} noValidate autoComplete="off">
            {form.map(item => {
              return this.generateFormItem(item);
            })}
          </form>
        </PageContainer>
      </div>
    );
  }
}

export default withTranslation()(CreateObjectivePage);
